import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useScrollStore = defineStore('scroll', () => {
  const scrollTop = ref(0)
  const scrollBoxHeight = ref(0)
  function setScrollTop(value: number) {
    scrollTop.value = value
  }
  function setScrollBoxHeight(value: number) {
    scrollBoxHeight.value = value
  }
  return { scrollTop, scrollBoxHeight, setScrollTop, setScrollBoxHeight }
})
